import { defineMessages, type IntlShape } from 'react-intl';

import type { JSONSchema } from '@plone/types';

export const showCarouselButtons = ({
  schema,
  intl,
  formData,
  fieldsetName,
  beforeField,
}: {
  schema: JSONSchema;
  intl: IntlShape;
  formData: JSONSchema;
  fieldsetName: string;
  beforeField: string;
}): JSONSchema => {
  schema.fieldsets = schema.fieldsets.map((fieldset) => {
    let fieldsetIndex = schema.fieldsets.findIndex(
      (x) => x.id === fieldsetName,
    );

    let position = schema.fieldsets[fieldsetIndex]?.fields.indexOf(beforeField);

    if (fieldset.id === 'default') {
      const updatedFields = [...fieldset.fields];
      updatedFields.splice(position, 0, 'showCarouselButtons');
      return {
        ...fieldset,
        fields: updatedFields,
      };
    }
    return fieldset;
  });
  schema.properties['showCarouselButtons'] = {
    title: intl.formatMessage(messages.showCarouselButtons),
    type: 'boolean',
    default: 'false',
  };
  return schema;
};

const messages = defineMessages({
  showCarouselButtons: {
    id: 'showCarouselButtons',
    defaultMessage: 'Show carousel buttons',
  },
});
